import React from 'react';
import { FaRegBell } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function NotificationEmpty({ system = false }) {
  const { t } = useTranslation();
  return <div className="notification-empty" role="status">
    <span className="notification-empty-icon"><FaRegBell aria-hidden="true" /></span>
    <strong>{t(system ? 'notifications.noSystemNotifications' : 'notifications.noAlertNotifications')}</strong>
    <p>{system
      ? t('notifications.systemEmptyHint', 'Account and platform updates will appear here.')
      : t('notifications.alertEmptyHint', 'Your triggered alerts will appear here.')}</p>
  </div>;
}
